import { Component } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    standalone: false
})
export class TextAreaComponent extends BaseControlComponent {
    static componentName = "TextAreaComponent";

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }
}